
import {
  defineComponent,
  nextTick,
  onMounted,
  onUnmounted,
  PropType,
  ref,
  watch
} from 'vue'
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'

interface Image {
  src: string
  alt: string
}

export default defineComponent({
  props: {
    images: {
      type: Array as PropType<Image[]>,
      default: () => []
    }
  },

  setup(props) {
    Swiper.use([Navigation, Pagination])
    let mySwiper: any = null
    const isSliderActive = ref(false)
    const breakpoint = 568

    const initSlider = () => {
      mySwiper = new Swiper('.swiper-container', {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          568: {
            slidesPerView: 2.1,
            centeredSlides: true,
            spaceBetween: 40,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            loop: true
          }
        }
      })
      isSliderActive.value = true
    }

    watch(
      () => props.images,
      () => {
        nextTick(() => {
          if (
            (props.images.length <= 1 && mySwiper) ||
            (props.images.length === 2 &&
              window.innerWidth >= breakpoint &&
              mySwiper)
          ) {
            mySwiper.destroy(false, true)
            mySwiper = null
            isSliderActive.value = false
          } else {
            if (mySwiper) {
              mySwiper.update()
            } else if (
              props.images.length >= 3 ||
              (props.images.length >= 2 && window.innerWidth < breakpoint)
            ) {
              initSlider()
            }
          }
        })
      }
    )

    const resizeUpdate = () => {
      if (
        props.images.length === 2 &&
        window.innerWidth >= breakpoint &&
        mySwiper
      ) {
        mySwiper.destroy(false, true)
        mySwiper = null
        isSliderActive.value = false
      }
      if (
        props.images.length === 2 &&
        window.innerWidth < breakpoint &&
        !mySwiper
      ) {
        initSlider()
      }
    }

    window.addEventListener('resize', resizeUpdate)
    onUnmounted(() => window.removeEventListener('resize', resizeUpdate))

    onMounted(() => {
      if (
        props.images.length <= 1 ||
        (props.images.length === 2 && window.innerWidth >= 568)
      )
        return

      initSlider()
    })

    return {
      isSliderActive
    }
  }
})
